<template>
	<div class="setting">
        <!-- left panel -->
        <el-col :span="5" class="setting-categories">
            <div v-if="this.$store.state.isSystemAdminMode">
                <div class="setting-category" 
                :class="settingCategory === 0 ? 'onSetttng' : ''" @click="setCategory(0)">
                    熱門主題
                </div>
                <div class="setting-category" 
                :class="settingCategory === 1 ? 'onSetttng' : ''" @click="setCategory(1)">
                    統計報表
                </div>
                <div class="setting-category" 
                :class="settingCategory === 2 ? 'onSetttng' : ''" @click="setCategory(2)">
                    學院主題分類
                </div>
            </div>
            <div v-else-if="this.$store.state.isBackendMode">
                <div class="setting-category" 
                :class="settingCategory === 3 ? 'onSetttng' : ''" @click="setCategory(3)">
                    部門主題分類排序
                </div>
            </div>
            <div>
                <div class="setting-category" 
                :class="settingCategory === 4 ? 'onSetttng' : ''" @click="setCategory(4)">
                    個人主題分類排序
                </div>
            </div>
        </el-col>
        <!-- right panel -->
        <el-col :span="19">
            <div class="setting-title">
                {{ categoryTitle }} 
                <div class="sub-setting-title">
                    {{ subCategoryTitle }} 
                    <div style="display:inline;">
                        <el-button type="text" style="text-decoration:underline;" @click="restoreCategoryOrder"
                            v-if="settingCategory === 3 || settingCategory === 4">
                            恢復預設值
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="setting-table" trigger="hover">
                <el-row v-if="settingCategory === 0" class="setting-item">
                    <el-col :span="10">
                        <div >
                            熱門主題統計區間
                        </div>
                    </el-col>
                    <div v-if="topicRange.isEdit" class="setting-content">
                        <el-col :span="9">
                            最近
                            <el-input size="small" style="width:50px" v-model.number="topicRange.value"></el-input>
                            天
                        </el-col>
                        <el-col :span="4">
                            <el-button size="small" @click="saveEdit(topicRange)">儲存</el-button>
                            <el-button size="small" @click="cancelEdit(topicRange)">取消</el-button>
                        </el-col>
                    </div>
                    <div v-else class="setting-content">
                        <el-col :span="12">
                            <div>
                                最近 {{ topicRange.value }} 天
                            </div>
                        </el-col>
                        <el-col :span="2">
                            <img src="../../assets/icon/ic_edit_blue.png" alt="E" 
                            class="edit-icon" @click="setEdit(topicRange)">
                        </el-col>
                    </div>
                </el-row>
                <el-row v-else-if="settingCategory === 1">
                    <el-row v-for="(item, index) in reportSetting" :key="index" class="setting-item" :class="getExtraRowStyle(index)">
                        <el-col :span="10">
                            <div >
                                {{ item.title }}
                            </div>
                        </el-col>
                        <div v-if="item.isEdit" class="setting-content">
                            <el-col :span="9">
                                {{ item.descPre }}
                                <el-input size="small" style="width:50px"
                                v-model.number="item.value"></el-input>
                                {{ item.descPost }}
                            </el-col>
                            <el-col :span="4">
                                <el-button size="small" @click="saveEdit(item)">儲存</el-button>
                                <el-button size="small" @click="cancelEdit(item)">取消</el-button>
                            </el-col>
                        </div>
                        <div v-else class="setting-content">
                            <el-col :span="12">
                                <div>
                                    {{ item.descPre }} {{ item.value }} {{ item.descPost }}
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <img src="../../assets/icon/ic_edit_blue.png" alt="E" 
                                class="edit-icon" @click="setEdit(item)">
                            </el-col>
                        </div>
                    </el-row>
                </el-row>
                <el-row v-else-if="settingCategory === 2">
                    <College :collegeList="categoryGroupList" @getCategoriesGroup="getCategoriesGroup"></College>
                </el-row>
                <el-row v-else-if="settingCategory === 3">
                    <CategoryOrder :key="refreshKey" :categoryGroupList="categoryGroupList" type="dep"></CategoryOrder>
                </el-row>
                <el-row v-else-if="settingCategory === 4">
                    <CategoryOrder :key="refreshKey" :categoryGroupList="categoryGroupList" type="user"></CategoryOrder>
                </el-row>
                <el-row v-else>
                </el-row>
            </div>
        </el-col>
        <hint v-show="hint.display && this.$store.state.hintStatus.setting" :message="hint.message" @close="closeHint"></hint>  
    </div>
</template>
<script>
import API from '../../api/api';
import College from './College';
import CategoryOrder from './CategoryOrder';
export default {
    components: { 
        College,
        CategoryOrder, 
    },
    props: {
        categoryGroupList: {
            type: Array
        }
    },
    name: 'Setting',
    data() {
        return {
            settingCategory: -1,
            categoryTitle: "",
            subCategoryTitle: "",
            topicRange: {
                key: "popular_resources_period",
                value: null,
                tmp: null,
                isEdit: false,
            },
            reportSetting: {
                usage: {
                    title: "使用率定義",
                    descPre: "看檔案",
                    descPost: "則",
                    key: "usage_rate",
                    value: null,
                    tmp: null,
                    isEdit: false,
                },
                active1: {
                    title: "活躍率定義1",
                    descPre: "看檔案超過",
                    descPost: "分鐘",
                    key: "active_rate_watch_time",
                    value: null,
                    tmp: null,
                    isEdit: false,
                },
                active2: {
                    title: "活躍率定義2",
                    descPre: "看檔案(一天內)超過",
                    descPost: "次",
                    key: "active_rate_watch_freq_in_one",
                    value: null,
                    tmp: null,
                    isEdit: false,
                },
                active3: {
                    title: "活躍率定義3",
                    descPre: "看檔案(不同2天)超過",
                    descPost: "次",
                    key: "active_rate_watch_freq_in_two",
                    value: null,
                    tmp: null,
                    isEdit: false,
                },
            },
            hint: {
                message: '',
                display: false,
            },
            refreshKey: 0,
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.initial();
                }
            }
        }
    },
    methods: {
        getCategoriesGroup() {
            this.$emit('getCategoriesGroup');
        },
        initial: function() {
            if (this.$store.state.isSystemAdminMode) {
                this.initSystemAdminSetting();
                this.setCategory(0);
            } else if (this.$store.state.isBackendMode) {
                this.setCategory(3);
            } else {
                this.setCategory(4);
            }
        },
        initSystemAdminSetting() {
            //取得系統設定
            API.getConfigs().then((result) => {
                if(result.status) {
                    redirectLogin(result.data);
                    if(!JSON.parse(result.request.response).error_msg) {
                        this.showHint('取得系統設定錯誤!');
                    } else {
                        this.showHint(JSON.parse(result.request.response).error_msg);	
                    }
                } else {
                    let r = result.result;
                    this.topicRange.value = r.find(o => o.key === this.topicRange.key).value;

                    for (var index in this.reportSetting) {
                        let item = r.find(o => o.key === this.reportSetting[index].key);
                        if (item) {
                            this.reportSetting[index].value = item.value;
                        }
                    }
                }
            });
        },
        setCategory: function(index) {
            this.categoryTitle = "";
            this.subCategoryTitle = "";

            if (index === 3 || index === 4) {
                this.$store.state.categoryGroupReady = false;
                this.getCategoriesGroup();
            }

            this.settingCategory = index;
            switch (index) {
                case 0:
                    this.categoryTitle = "熱門主題";
                    break;f
                case 1:
                    this.categoryTitle = "統計報表";
                    break;
                case 2:
                    this.categoryTitle = "學院主題分類";
                    break;
                case 3:
                    this.categoryTitle = "部門主題分類排序";
                    this.subCategoryTitle = "勾選部門預設顯示的主題分類與調整排序";
                    break;
                case 4:
                    this.categoryTitle = "個人主題分類排序";
                    this.subCategoryTitle = "勾選欲顯示的主題與調整排序";
                    break;
                default:
                    break;
            }
        },
        setEdit: function(item) {
            item.tmp = item.value;
            item.isEdit = true;
        },
        cancelEdit: function(item) {
            item.value = item.tmp;
            item.isEdit = false;
        },
        saveEdit: function(item) {
            if (!Number.isInteger(item.value) || item.value < 1) {
                this.showHint('請輸入正整數!');
                return;
            }
            if (item.isEdit) {
                API.putConfig(item.key, item.value).then((response) => {
                    if(response.status) {
                        redirectLogin(response.data);
                        if(!JSON.parse(response.request.response).error_msg) {
                            this.showHint('修改系統設定錯誤!');
                        } else {
                            this.showHint(JSON.parse(response.request.response).error_msg);	
                        }
                    } else {
                        item.isEdit = false;
                    }
                });
            }
        },
        restoreCategoryOrder() {
            var type = 'user';
            if (this.settingCategory === 3) {
                type = 'dep';
            }
            API.restoreCategoryOrder(type).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.$message.error('恢復分類排序發生錯誤!');
                    } else {
                        this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    this.$store.state.isCategoryUpdated = true;
                    this.refreshKey += 1;
                }
            });
        },
        /**
        * closeHint close hint 視窗
        * @return none
        */
        closeHint: function() {
            this.hint.display = false;
            this.$store.state.hintStatus.setting = false;
            clearTimeout(this.timer);
        },
        /**
        * showHint 
        * @param  {string} message - message
        * @return none
        */
        showHint: function(message) {
            if(this.timer) {
                clearTimeout(this.timer);	
            }
            this.hint.display = true;
            this.hint.message = message;	
            this.$store.state.showHint = true;
            this.$store.state.hintStatus.setting = true;
            this.timer = setTimeout(()=>{
                if(this.$store.state.showHint) {
                    this.$store.state.showHint = false;
                    this.$store.state.hintStatus.info = false;
                }
            }, this.$store.state.fadeOutTime);
        },
        getExtraRowStyle(index) {
            if (index === "usage") {
                return "";
            } else if (index === "active1") {
                return "setting-item-gap";
            } else {
                return "setting-item-cont";
            }
        },
    },
    created() {
        this.$store.state.nowStatus = 11;
    }
}
</script>
<style lang="scss">
$border-color: #D5D5D4;
$border-color2: #EEEEEE;
.setting {
	margin-top : 22px;

    .setting-categories {
		background-color: white;
		border: $border-color2 1px solid;
    	height: 250px;
    	float: left;

        .setting-category {
            line-height: 24px;
            display: inline-block;
            margin-left: 15px;	
            margin-top: 20px;
            padding-bottom: 15px;	
            border-bottom: 1px solid $border-color;
            width: 80%;
            font-size: 16px;
            color: #515151;
            cursor: pointer;
        }

        .onSetttng {
            color: #1D2327;
            font-weight: 500;
        }
    }

    .setting-title {
        margin-left: 30px;
        color: #3C3B38;
        font-size: 24px;
        font-weight: 500;

        .sub-setting-title {
            display: inline-block;
            font-size: 16px;
            font-weight: 400;
        }
    }

    .setting-table {
        margin-left: 20px;
        margin-top: 30px;
        
        .setting-item {
            border: 1px solid $border-color;
            background-color:  white;
            height: 60px;
            line-height: 60px;
            padding-left: 20px;
            color: #515151;
            font-size: 14px;
            font-weight: 500;

            .setting-content {
                text-align: right;
            }
        }

        .setting-item:hover {
            color: #2E90F4;
            background: #F0F7FF;
            border: 1px solid #2E90F4;

            .edit-icon {
                display: block;
            }
        }

        .setting-item-cont {
            border-top: 0px;
        }

        .setting-item-gap {
            margin-top: 30px;
        }

        .edit-icon {
            display: none;
            height: 24px;
            width: 24px;
            right: 20px;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// Setting.vue?2a063d0a